import { render } from "./01_Slider.vue?vue&type=template&id=36bfae96&scoped=true"
import script from "./01_Slider.vue?vue&type=script&lang=js"
export * from "./01_Slider.vue?vue&type=script&lang=js"

import "./01_Slider.vue?vue&type=style&index=0&id=36bfae96&lang=css"
import "./01_Slider.vue?vue&type=style&index=1&id=36bfae96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36bfae96"]])

export default __exports__